import { render, staticRenderFns } from "./ThirdPartyBusinessRisksTable.vue?vue&type=template&id=5b5793e5&"
import script from "./ThirdPartyBusinessRisksTable.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyBusinessRisksTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports